import React from 'react'
import DndItem from './DndItem.jsx'

const DndComponentGallery = (props) => {

        return (
            <div>
                {props.doc &&
                    <div>
                    </div>
                }
                <DndItem onDrop={props.onDrop} sortData='chooser'/>
            </div>
        )
}

export default DndComponentGallery


// WEBPACK FOOTER //
// ./src/components/common/DndGallery.jsx